"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAdSetToExperimentMappingRequestToJSON = exports.CreateAdSetToExperimentMappingRequestFromJSONTyped = exports.CreateAdSetToExperimentMappingRequestFromJSON = exports.instanceOfCreateAdSetToExperimentMappingRequest = void 0;
var AdSetType_1 = require("./AdSetType");
/**
 * Check if a given object implements the CreateAdSetToExperimentMappingRequest interface.
 */
function instanceOfCreateAdSetToExperimentMappingRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "experimentId" in value;
    isInstance = isInstance && "questionId" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfCreateAdSetToExperimentMappingRequest = instanceOfCreateAdSetToExperimentMappingRequest;
function CreateAdSetToExperimentMappingRequestFromJSON(json) {
    return CreateAdSetToExperimentMappingRequestFromJSONTyped(json, false);
}
exports.CreateAdSetToExperimentMappingRequestFromJSON = CreateAdSetToExperimentMappingRequestFromJSON;
function CreateAdSetToExperimentMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentId': json['experiment_id'],
        'questionId': json['question_id'],
        'type': (0, AdSetType_1.AdSetTypeFromJSON)(json['type']),
    };
}
exports.CreateAdSetToExperimentMappingRequestFromJSONTyped = CreateAdSetToExperimentMappingRequestFromJSONTyped;
function CreateAdSetToExperimentMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_id': value.experimentId,
        'question_id': value.questionId,
        'type': (0, AdSetType_1.AdSetTypeToJSON)(value.type),
    };
}
exports.CreateAdSetToExperimentMappingRequestToJSON = CreateAdSetToExperimentMappingRequestToJSON;
